export const theme = {
  colors: {
    white: "#FFFFFF",
    black: "#040D1B",
    lightGrey: "#DADADA",
    secondaryBlack: "#0F1928",
    secondaryGrey: "#878787",
    primary: "#E2577F",
    purple: "#4E3FE4",
    lightWhite: "#FFFFFF33",
    darkGrey: "#333B48",
  },
  fonts: {
    poppins: "Poppins",
    inter: "Inter",
  },
  fontWeights: {
    bold: 600,
    semibold: 500,
    normal: 400,
  },

  zIndex: {
    10: 10,
    20: 20,
    30: 30,
  },
};
